export default __webpack_public_path__ + "static/media/lockers-shelf.da9db623.svg";